import { render, staticRenderFns } from "./PaperAirplane.vue?vue&type=template&id=ee9f238e"
import script from "./PaperAirplane.vue?vue&type=script&lang=js"
export * from "./PaperAirplane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports